// extracted by mini-css-extract-plugin
export default {"container":"dUR8oD","title":"VbnEc9","textButton":"evLPK1"};